import type { TViewedOfficeScope } from '~/types/ViewedOfficeScope';

export const VIEWED_OFFICE_PARAM = 'officeId';
export const VIEWED_SCOPE_PARAM = 'scope';
export const ORGANIZATION_SCOPE = 'organization';

export const SELECTED_OFFICE_SCOPE: TViewedOfficeScope = { kind: 'selected' };

/** The location's id when the scope is one location, else `undefined` (the selected office). */
export const getViewedOfficeId = (scope: TViewedOfficeScope | undefined): string | undefined =>
  scope?.kind === 'location' ? scope.officeId : undefined;

export const isSameViewedOfficeScope = (a: TViewedOfficeScope, b: TViewedOfficeScope): boolean =>
  a.kind === b.kind && getViewedOfficeId(a) === getViewedOfficeId(b);

/** `route` with the scope in its query string, the form `useViewedOfficeScope` reads. */
export const toViewedOfficePath = (route: string, scope: TViewedOfficeScope): string => {
  if (scope.kind === 'location') {
    return `${route}?${new URLSearchParams({ [VIEWED_OFFICE_PARAM]: scope.officeId })}`;
  }
  if (scope.kind === 'organization') {
    return `${route}?${new URLSearchParams({ [VIEWED_SCOPE_PARAM]: ORGANIZATION_SCOPE })}`;
  }
  return route;
};

/**
 * The `x-office` a request for `scope` carries, layered over `getAuthHeaders`: the
 * location's own, none for the organization (the caller's whole tree), and the
 * selected office's — nothing to override — otherwise. A header set to `undefined`
 * is dropped by axios, as `mainAccountHeaders` in `services/api.js` relies on.
 */
export const toViewedOfficeHeaders = (
  scope: TViewedOfficeScope | undefined,
): Record<string, string | undefined> => {
  if (scope?.kind === 'location') return { 'x-office': scope.officeId };
  if (scope?.kind === 'organization') return { 'x-office': undefined };
  return {};
};
